import React, { useEffect, useRef, useState } from 'react';

export default function ValidationErrorPopup({
    isOpen,
    onClose,
    errors = []
}) {
    const popupRef = useRef(null);
    const [currentErrorIndex, setCurrentErrorIndex] = useState(0);

    useEffect(() => {
        if (isOpen) setCurrentErrorIndex(0);
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen) return;

        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen, onClose]);

    if (!isOpen || errors.length === 0) return null;

    const currentError = errors[currentErrorIndex];

    const handleOK = () => {
        if (currentError.fieldRef?.current) {
            currentError.fieldRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            currentError.fieldRef.current.classList.add('highlight-error');
            setTimeout(() => {
                currentError.fieldRef.current?.classList.remove('highlight-error');
            }, 1500);
        }
        onClose();
    };

    return (
        <div className="feedback-notification-overlay">
            <div className="scroll-picker-modal" ref={popupRef}>

                <p className="feedback-title"
                    style={{
                        color: "#667eea",
                        textAlign: "center",
                        padding: "10% 5%"
                    }}>

                    {currentError.message}
                </p>

                {/* Actions */}
                <div className="feedback-actions"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                    <button
                        className="scroll-picker-header"
                        onClick={handleOK}
                        style={{
                            border: "2px white",
                            borderRadius: "10px"
                        }}
                    >
                        OK, Got It!
                    </button>
                </div>
            </div>
        </div>
    );
}
